import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { PressStrip } from "@/components/site/PressStrip";
import { Ticker } from "@/components/site/Ticker";
import { Manifesto } from "@/components/site/Manifesto";
import { LoopReel } from "@/components/site/LoopReel";
import { SystemSection } from "@/components/site/SystemSection";
import { HowItWorks } from "@/components/site/HowItWorks";
import { VideoShowcase } from "@/components/site/VideoShowcase";
import { ResultsSlider } from "@/components/site/ResultsSlider";
import { Features } from "@/components/site/Features";
import { FounderNote } from "@/components/site/FounderNote";
import { Pricing } from "@/components/site/Pricing";
import { Faq } from "@/components/site/Faq";
import { Waitlist } from "@/components/site/Waitlist";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="relative">
      {/* grain overlay */}
      <div className="pointer-events-none fixed inset-0 z-[100] noise opacity-[0.035] mix-blend-overlay" />
      <Header />
      <main>
        <Hero />
        <PressStrip />
        <Ticker />
        <Manifesto />
        <LoopReel />
        <SystemSection />
        <HowItWorks />
        <VideoShowcase />
        <ResultsSlider />
        <Features />
        <FounderNote />
        <Pricing />
        <Faq />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
